export default __webpack_public_path__ + "static/media/exterior-1_cropped.516dafdb.webp";